// extracted by mini-css-extract-plugin
export default {"container":"ChangePasswordForm_container__ELvNe","headerContainer":"ChangePasswordForm_headerContainer__NwWtG"};